import React from 'react';
import { useMutation, useQuery } from '@apollo/client';
import { GET_JOB_EMOCS, LINK_EMOC_JOBS, UPDATE_EMOC } from '../../../graph-queries/tar/emoc';
import { TEmoc } from '../../../lib/types';
import AspectsTable from '../AspectsTable/AspectsTable';
import EmocForm from '../EmocForm/EmocForm';
import { columns } from '../../pages/Emocs/Emocs';
import classes from './JobAspects.module.scss';
import { useParams } from 'react-router-dom';
import { useSelectedAsset } from '../../../lib/util';
import { useHasTarAdminAccess, useHasUserAccess } from '../../../lib/util/auth';

const JobEmocs: React.FC = () => {
  const { jobId: param } = useParams();
  const hasUserAccess = useHasUserAccess();
  const hasTarAdminAccess = useHasTarAdminAccess();
  const asset = useSelectedAsset();
  const jobId = parseInt(param || '-1');
  const { data, loading } = useQuery(GET_JOB_EMOCS, {
    variables: { jobId, assetId: asset?.assetId || -1 },
  });
  const [updateEmoc] = useMutation(UPDATE_EMOC, {
    refetchQueries: [GET_JOB_EMOCS],
  });
  const [linkEmocJobs] = useMutation(LINK_EMOC_JOBS, {
    refetchQueries: [GET_JOB_EMOCS],
  });

  const onEditSubmit = (emoc: TEmoc) => {
    const { updatedBy, updatedAt, tarJobs, ...input } = emoc;
    return updateEmoc({ variables: { input } });
  };

  const onLinkSubmit = (selection: TEmoc[], jobIds: number[]) => {
    return Promise.all(
      selection.map((emoc) =>
        linkEmocJobs({
          variables: {
            mocId: emoc.mocId,
            jobIds: jobIds,
          },
        })
      )
    );
  };

  return (
    <AspectsTable<TEmoc>
      aspectName="emoc"
      data={(data?.emocsByJobId as unknown as TEmoc[]) || []}
      onLinkSubmit={onLinkSubmit}
      columns={columns}
      renderEditForm={(onClose, defaultValue) => (
        <EmocForm
          defaultValues={defaultValue}
          onSubmit={onEditSubmit}
          onClose={onClose}
          type={'edit'}
        />
      )}
      creationDisabled={!hasUserAccess}
      getRowMutationDisabled={(_row) => !hasUserAccess}
      getRowDeletionDisabled={(_row) => !hasTarAdminAccess}
      hideSelectionColumn
      renderBare
      title={<div className={classes.title}>MOC</div>}
    />
  );
};

export default JobEmocs;
